function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7,
  fill: "#9698A4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.4711 5.52854C10.7315 5.78889 10.7315 6.211 10.4711 6.47135L6.47115 10.4714C6.2108 10.7317 5.78869 10.7317 5.52834 10.4714C5.26799 10.211 5.26799 9.78889 5.52834 9.52854L9.52834 5.52854C9.78869 5.2682 10.2108 5.2682 10.4711 5.52854Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.52834 5.52854C5.78869 5.2682 6.2108 5.2682 6.47115 5.52854L10.4711 9.52854C10.7315 9.78889 10.7315 10.211 10.4711 10.4714C10.2108 10.7317 9.78869 10.7317 9.52834 10.4714L5.52834 6.47135C5.26799 6.211 5.26799 5.78889 5.52834 5.52854Z",
  fill: "white"
});

var SvgCircleCrossGray = function SvgCircleCrossGray(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircleCrossGray, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/circleCrossGray.55f59c4f.svg";
export { ForwardRef as ReactComponent };